<template>
  <div>
    <div class="editor-wrapper">
        <monaco-editor
          class="editor"
          ref="editor"
          v-model="code"
          :language="language"
          :options="editorOptions"
          @change="clearMarkers"
          theme="vs">
        </monaco-editor>
    </div>
    <div class="btn-wrapper">
        <button @click="run">Uruchom program</button>
    </div>
    <div class="terminal-wrapper">
        <div class="terminal-overlay">Kliknij przycisk URUCHOM PROGRAM, aby sprawdzić poprawność swojego kodu.</div>
        <div class="terminal-inner">
            <Terminal 
                :bus="terminalBus" 
            />
        </div>
    </div>
    <ExerciseInput v-if="renderInput" :terminalBus="terminalBus" />
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco'
import Terminal from '@/components/Terminal'
import Vue from 'vue';
import python from '@/runtime/python'
import cpp from '@/runtime/cpp'
import * as monaco from 'monaco-editor'
import OutputValidator from '@/services/OutputValidator'
import ExerciseInput from '@/components/ExerciseInput'
import testRunner from '@/services/TestRunner'

export default {
  components: {
    MonacoEditor,
    Terminal,
    ExerciseInput
  },

  props: {
    language: {
      required: true,
      type: String
    },
    initialCode: {
      required: false,
      type: String
    },
    expectedOutput: {
      required: false,
      type: String
    },
    renderInput: {
      required: false,
      type: Boolean,
      default: false
    },
    tests: {
      required: false
    },
    runtimeConfig: {
      required: true
    }
  },

  data() {
    return {
      editorOptions: {
        minimap: {
          enabled: false
        },
        autoIndent: true
      },
      terminalBus: new Vue(),
      testRunner: testRunner,
      code: this.initialCode,
      outputValidator: undefined
    }
  },

  computed: {
      editor () {
        return this.$refs.editor.getMonaco()
      },
      currentRuntime () {
        return this.language === 'python' ? python : cpp;
      }
  },

  watch: {
    currentRuntime: {
      handler (currentRuntime) {
        this.code = currentRuntime.exampleCode;
      }
    }
  },

  mounted () {
    monaco.languages.setLanguageConfiguration('python', {
      indentationRules: {
        increaseIndentPattern: /^.*?:\s*$/
      }
    });
    this.currentRuntime.configure(this.runtimeConfig);
    if (this.expectedOutput) {
      this.outputValidator = new OutputValidator(this.terminalBus, this.expectedOutput)
    }
  },

  methods: {
    getLine (number) {
        return this.code.split('\n')[number - 1]
    },
    clearMarkers () {
        monaco.editor.setModelMarkers(this.editor.getModel(), null, [])
    },
    async run () {
      await this.currentRuntime.run(this.terminalBus, this.editor, this.code, !(this.expectedOutput || this.tests));
      Vue.nextTick(async () => {
          let valid = true;
          if (this.expectedOutput && !this.outputValidator.isValid) {
              valid = false;
          }

          if (this.tests) {
              valid = valid && await this.testRunner.runTests(this.currentRuntime, this.terminalBus, this.code, this.tests);
          }

          if (!valid) {
              this.terminalBus.$emit(
                  'writeMessage',
                  '\x1B[1;3;31mMusisz coś jeszcze poprawić\x1B[0m\n'
              );
          } else if (this.tests || this.expectedOutput) {
              this.terminalBus.$emit(
                  'writeMessage',
                  '\x1B[1;3;32mGratulacje, zadanie zostało wykonane poprawnie!\x1B[0m\n'
              );
          }
      });
    }
  }
}
</script>

<style>
.editor {
  width: 100%;
  height: 300px;
}
</style>
